module.exports = __webpack_public_path__ + "media/Recruit_Video_Banner_Sm.9be59e5c.mp4";